import { Components, Theme } from '@mui/material';

export const getMuiChip = (theme: Theme): Components['MuiChip'] => ({
  styleOverrides: {
    root: {
      variants: [
        {
          props: { variant: 'watchduty' },
          style: {
            borderRadius: 4,
            fontWeight: theme.typography.fontWeightBold,
            fontSize: theme.typography.subtitle1.fontSize,
            fontVariant: 'small-caps',
            textTransform: 'lowercase',
            marginBottom: 4,
            lineHeight: 1,
            height: 'auto',
            '& span': {
              height: 'fit-content',
              padding: '2px 6px 2px',
              display: 'block',
              whiteSpace: 'normal',
            },
          },
        },
        {
          props: { variant: 'keyboard-shortcut' },
          style: {
            fontFamily: 'monospace',
            borderRadius: '4px',
            backgroundColor: theme.palette.grey[800],
            margin: 0,
            padding: 0,
            '& span': {
              padding: '0 6px',
              margin: 0,
            },
          },
        },
      ],
    },
  },
});
